<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<template>
  <v-container id="document_signature_customization_root" fluid>
    <implicit-authorization-modal
      :key="implicitAuthorizationModalKey"
      :signature-guid="implicitGuid"
      :request-loading-dialog-showed=" ImplicitAuthorizationModalVisible"
    ></implicit-authorization-modal>
    <!-- header -->
    <v-row class="mb-6 px-6" justify="center" align="center">
      <v-btn
        id="back_button"
        class="elevation-0 pl-0 pr-3"
        color="black--text grey lighten-2"
        @click="back"
      >
        <v-icon
          class="ma-0 pa-0"
          color="grey darken-3"
        >
          mdi-chevron-left
        </v-icon>
        {{ $t('main.back') }}
      </v-btn>
      <v-col cols="7">
        <span class="text-h5">
          {{ chainContainer.batch?.name }}</span>
      </v-col>

      <v-col class="d-flex flex-row justify-end">
        <v-btn
          id="signature_confirmation_sign_btn"
          class="mx-4 px-4"
          color="success"
          :disabled="!isFormValid"
          :loading="isUploading || authorizationModalBtnLoading"
          @click=" (isSealSignMode || isImplicitCredential(selectedCredential.authMode)
            ? signDoc()
            : showAuthorizationModal())"
        >
          <v-icon class="mr-1 ml-0">mdi-draw-pen</v-icon>
          {{ $t('main.sign') }}
        </v-btn>
        <v-btn
          color="error"
          outlined
          class="px-2"
          :loading="isUploading"
          @click="showDeclineModal($event)"
        >
          <v-icon
            class="mr-1 ml-0"
          >
            mdi-close-circle-outline
          </v-icon>
          {{ $t('dataTable.content.action.decline') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      align="stretch"
      align-content="space-between"
    >
      <v-col md="6" sm="12" align="start">
        <!-- SIGNATURE + CRED  CONFIG-->
        <v-card v-show="pdfRendered">
          <v-container class="d-flex flex-column">
            <v-form ref="form" v-model="formValid" @input="handleFormValidityChange">
              <v-row>
                <v-col>
                  <p v-show="showBlueWarning" class="BlueWarning">{{ $t('documentSignatureCustomization.warning.someCredendetialHaveProblem') }}</p>
                  <p class="BlueWarning">{{ $t('documentSignatureCustomization.content.signature.asicSign.visibleSignatureExplainer') }}</p>

                  <v-switch
                    v-show="(sealActivated && activatedCredentials.length > 0)"
                    v-model="useDifferentCredential"
                    :label="$t('documentSignatureCustomization.content.signature.useDifferentCredential')"
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row
                v-if="useDifferentCredential || !sealActivated"
              >
                <v-col>
                  <v-divider role="presentation"></v-divider>
                  <v-select
                    v-if="activatedCredentials.length > 0"
                    id="signature_customization_credential_select"
                    v-model="selectedCredential"
                    class="mx-3 mt-5"
                    :items="activatedCredentials"
                    :item-text="item => item.description"
                    item-value="id"
                    :label="$t('documentSignatureCustomization.content.signature.selectSigningCredential') + `*`"
                    :rules="[rules.required]"
                    return-object
                    @input="$refs.form.resetValidation()"
                  >
                    <template #default.item="{item}">
                      <div class="option_active_credential">
                        {{ item }}
                      </div>
                    </template>
                  </v-select>
                  <p v-show="showBlueWarning" class="BlueWarning">{{ $t('documentSignatureCustomization.warning.someCredendetialHaveProblem') }}</p>
                </v-col>
              </v-row>
              <v-card class="mt-6 pa-4">
                <v-list shaped>
                  <v-list-item-group v-model="currentDoc" mandatory @change="downloadDocument(currentDoc)">
                    <v-list-item v-for="doc in containedDocuments" :key="doc.id" :value="doc">
                      <v-list-item-content>
                        <v-list-item-title v-text="doc.fileName"></v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-icon>
                          mdi-chevron-right
                        </v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-form>
          </v-container>
        </v-card>
      </v-col>
      <!-- visibleSignatureComponent -->
      <v-col
        cols="6"
        md="6"
        sm="12"
        align="center"
        style="position: relative;"
      >
        <v-overlay
          :absolute="true"
          :value="isUploading"
        >
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
          ></v-progress-circular>
        </v-overlay>
        <visibleSignature
          ref="visibleSignature"
          :doc-data="documentBase64"
          @pdfLoaded="pdfLoaded"
          @passwordSpecified="handlePasswordSpecified"
        />
      </v-col>
    </v-row>
    <!-- authorizationModal -->
    <v-row justify="center">
      <v-dialog v-model="authorizationModal" persistent max-width="500">
        <v-card id="explicit_auth_modal">
          <v-card-title>
            <span class="headline">{{ $t('documentSignatureCustomization.modal.authorization.title') }}</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="authorizationModalForm" v-model="authorizationModalFormValid" @submit.prevent>
              <v-text-field
                id="explicit_authmodal_textfield"
                ref="passwordField"
                v-model="expAuthPwd.pwd"
                tabindex="1"
                :append-icon="expAuthPwd.showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                :label="$t('documentSignatureCustomization.modal.authorization.content.keyPassword') + `*`"
                :type="expAuthPwd.showPwd ? 'text' : 'password'"
                prepend-icon="mdi-lock"
                :rules="[rules.required, rules.passwordMustBeLongerThan, rules.onlyNumber]"
                @click:append="expAuthPwd.showPwd = !expAuthPwd.showPwd"
                @keydown.enter="signDoc()"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn text tabindex="3" @click="authorizationModal = false">{{ $t('main.cancel') }}</v-btn>
            <v-btn
              id="explicit_authmodal_signbtn"
              color="success"
              tabindex="2"
              :disabled="!authorizationModalFormValid"
              :loading="authorizationModalBtnLoading"
              @click="signDoc()"
            >
              {{ $t('documentSignatureCustomization.modal.authorization.content.button.sign') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="noCredentialWarningVisible" persistent width="auto" max-width="700">
        <v-card id="no_credential_warning" class="py-6 px-3">
          <v-card-title class="text-h6 red--text">
            {{ $t('signatureProfiles.error.noActivatedCredential.title') }}
          </v-card-title>
          <v-card-text>
            <div>
              {{ $t('signatureProfiles.error.noActivatedCredential.description') }}
            </div>
            <v-btn
              id="no_credential_warning_ok"
              style="text-align: center;"
              color="primary"
              to="/credentials"
              class="mt-10 mb-0"
            >
              <v-icon class="mr-1">mdi-folder-open-outline</v-icon>
              {{ $t('signatureProfiles.error.noActivatedCredential.button') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="noDeviceForImplicitCredentialWarningVisible" persistent max-width="550">
        <v-card id="no_device_warning" class="pa-6">
          <v-card-title class="text-h6 red--text">
            {{ $t('signatureProfiles.error.noActivatedDevice.title') }}
          </v-card-title>

          <v-card-text style="text-align: center">
            <v-container>
              <v-row justify="start">
                <div>
                  {{ $t('signatureProfiles.error.noActivatedDevice.description') }}
                </div>
                <div class="pt-6">
                  <v-btn
                    id="no_device_warning_ok"
                    color="primary"
                    to="/user/profile/"
                    class=" mb-0"
                  >
                    <v-icon class="mr-1">mdi-cellphone-key</v-icon>
                    {{ $t('signatureProfiles.error.noActivatedDevice.button') }}
                  </v-btn>
                </div>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="centralKeyEnabledAndnoProfileWarningVisible" persistent width="auto" max-width="700">
        <v-card id="no_credential_warning" class="py-6 px-3">
          <v-card-title class="text-h6 red--text">
            {{ $t('signatureProfiles.error.centralKeyEnabledAndNoProfile.title') }}
          </v-card-title>
          <v-card-text>
            <div>
              {{ $t('signatureProfiles.error.centralKeyEnabledAndNoProfile.description') }}
            </div>
            <v-btn
              id="no_credential_warning_ok"
              style="text-align: center;"
              color="primary"
              to="/signatureProfiles"
              class="mt-10 mb-0"
            >
              <v-icon class="mr-1">mdi-folder-open-outline</v-icon>
              {{ $t('signatureProfiles.error.centralKeyEnabledAndNoProfile.button') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row>
      <decline-reason-modal
        :visible="declineReasonVisible"
        :signature-id="getUserSignatureId(chainContainer)"
        :current-signature-id="getCurrentSignatureId(chainContainer)"
        @declined="back"
      ></decline-reason-modal>
    </v-row>
  </v-container>
</template>

<script>

import documents from '@/services/api/documents'
import rssp from '@/services/api/rsspUtil.js'
import signatureChains from '@/services/api/signatureChains'
import signatureProfiles from '@/services/api/signatureProfiles'
import signatures from '@/services/api/signatures'
import CommonError from '@/views/CommonError'
import RdssError from '@/views/RdssError'
import CredentialAuthMode from '../CredentialAuthMode'
import SignatureChainType from '../chains/SignatureChainType'
// import errorHandler from '../errorHandler'
import VisibleSignature from '@/components/VisibleSignature'
import { showConfirmationMenu, showRequestLoadingDialog, showToastError, showToastSuccess } from '@/event-bus'
import seal from '@/services/api/seal.js'
import { v4 as uuidv4 } from 'uuid'
import DeclineReasonModal from '../DeclineReasonModal'
import ImplicitAuthorizationModal from '../ImplicitAuthorizationModal'
import SignatureChainStatus from './SignatureChainStatus.js'

export default {
  name: 'AsicSignatureCustomization',

  components: {
    VisibleSignature,
    ImplicitAuthorizationModal,
    DeclineReasonModal
  },

  data() {
    return {
      formValid: true,
      documentBase64: null,
      document: {},
      pdfRendered: false,
      useDifferentCredential: false,
      sealStatus: {
        enabled: false,
        secureMode: false,
        activated: false
      },
      signatureProfiles: [],
      selectedSignatureProfile: {
        credentialId: ''
      },
      // signatureProfile: {},
      signatureImg: null,
      signatureTextSize: 14,
      activatedCredentials: [],
      myCredentials: [],
      encryptionDatas: [],
      selectedCredential: {},
      switchSignatureChainType: false,
      draftRecipients: [{ userId: null }],
      authorizationModalFormValid: false,
      authorizationModal: false,
      authorizationModalBtnLoading: false,
      // implicitAuthorizationModal
      implicitAuthorizationModalKey: 0,
      implicitGuid: '',
      devicesListTotalItems: 0,
      ImplicitAuthorizationModalVisible: false,
      showBlueWarning: false,
      noCredentialWarningVisible: false,
      noDeviceForCredentialWarningVisible: false,
      noDeviceForImplicitCredentialWarningVisible: false,
      authorizationTimeoutMilis: this.$store.state.remoteConfig ? this.$store.state.remoteConfig.authorizationTimeoutSecs * 1000 : null,
      // centralKeyId: 'central_key_id',
      centralKeyId: -1,
      originalSignatureProfiles: [],
      expAuthPwd: {
        pwd: null,
        showPwd: false
      },
      passwordMinCharacters: 6,

      rules: {
        // required: v => !!v || this.$t('validation.form.requiredField')
        required: (v) => !!v || !isNaN(parseFloat(v)) || this.$t('validation.form.requiredField'),
        passwordMustBeLongerThan: v => (v && v.length >= this.passwordMinCharacters) || this.$t('validation.form.passwordMustBeLongerThan', { min: this.passwordMinCharacters }),
        onlyNumber: v => (/^[0-9]+$/.test(v)) || this.$t('validation.form.onlyNumbers'),
        // credentialAlive: (v) => (!!(!!this.selectedCredential && (this.activatedCredentials.find(cred => cred.id === this.selectedSignatureProfile.credentialId) || !!this.selectedCredential.id))) || this.$t('validation.form.credentialIsDead')
        credentialAlive: (v) => {
          if (this.sealEnabled) {
            // profil, nem másik jog használata
            if (!this.useDifferentCredential && this.selectedSignatureProfile.useSeal) {
              return this.sealActivated || this.$t('validation.form.centralKeyIsNotActivated')
            }
          } else {
            return (!!(!!this.selectedCredential && (this.activatedCredentials.find(cred => cred.id === this.selectedSignatureProfile.credentialId) || !!this.selectedCredential.id))) || this.$t('validation.form.credentialIsDead')
          }
        }
      },

      isUploading: true,

      // decline reasoning:
      declineReasonVisible: false,
      // asic
      containedDocuments: [],
      currentDoc: {}

    }
  },

  computed: {
    currentUser() {
      return this.$store.state.currentUser
    },

    isFormValid() {
      if (this.sealActivated && (!this.selectedCredential || !this.selectedCredential.id)) {
        return false
      }

      const res = this.selectedCredential.description || this.isSealSignMode

      return res
    },

    sealActivated() {
      return this.sealStatus.enabled && this.sealStatus.activated
    },

    sealEnabled() {
      return this.sealStatus.enabled
    },
    centralKeyEnabledAndnoProfileWarningVisible() {
      return this.sealEnabled && this.signatureProfiles.length === 0 && this.activatedCredentials.length === 0
    },
    chainContainer() {
      return this.$store.state.currentChain
    },
    isSealSignMode() {
      return this.sealActivated && !this.useDifferentCredential
    }
  },

  watch: {
    selectedSignatureProfile(val) {
      if (val.credentialId !== undefined) {
        if (this.sealEnabled && (val.useSeal)) {
          if (!this.selectedCredential) {
            this.selectedCredential = {}
          }
          this.selectedCredential.id = val.credentialId
        } else {
          if (this.activatedCredentials.length > 0) {
            this.activatedCredentials.forEach(credential => {
              if (credential.id === val.credentialId) {
                this.selectedCredential = credential
              }
            })
          } else {
          // probably dead cred
            if (!this.selectedCredential) {
              this.selectedCredential = {}
            }
            /// this.selectedCredential.id = val.credentialId
            // this.selectedCredential = undefined
            this.selectedCredential.id = undefined
          }
        }
      } else {
      }
    },

    useDifferentCredential(val) {
      if (!val) {
        this.selectedCredential = {}
        if (this.sealEnabled) {
          this.selectedCredential.id = this.centralKeyId
        }
      } else {
        this.selectedCredential = this.activatedCredentials[0]
      }

      // this.$refs.form.resetValidation()
    }

  },

  async mounted() {
    if (!this.chainContainer) {
      this.back()
      return
    }
    await this.unpackContainer()
    await this.getSignatureProfiles()
    this.downloadDocument(this.containedDocuments[0])
    this.sealStatus = await seal.getSealStatus()
    if (this.sealActivated) {
      this.selectedCredential.id = this.centralKeyId
    }

    await this.listMyActivatedCredentials()

    await this.handleWarning()
  },
  destroyed() {
    this.$store.commit('removeCurrentChain')
  },

  methods: {
    async unpackContainer() {
      try {
        const batch = await documents.getBatch(this.chainContainer.batch.id)

        this.containedDocuments = await Promise.all(batch.documents.map(async d => documents.getDocument(d.id)))
      } catch (error) {
        console.error(error)
      }
    },
    handlePasswordSpecified(password) {
      this.document.password = password
    },
    async downloadDocument(doc) {
      this.isUploading = true
      try {
        if (!doc.blob) {
          const blob = await documents.downloadDocument(doc.id)
          doc.blob = blob
        }
        this.document = doc
        const base64 = await this.blobToBase64(doc.blob)

        const visibleSignatureComponent = this.$refs.visibleSignature
        if ((doc.security === 'ENCRYPTED_WITH_OWNER_PASSWORD') || (doc.security === 'ENCRYPTED_WITH_USER_PASSWORD')) {
          visibleSignatureComponent.updateEncryptionStatus(true)
          visibleSignatureComponent.setPassword(doc.password)
        } else {
          visibleSignatureComponent.updateEncryptionStatus(false)
          visibleSignatureComponent.setPassword(null)
        }

        this.documentBase64 = base64.split(',')[1]
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      } finally {
        // this.isUploading = false
      }
    },

    blobToBase64(blob) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.readAsDataURL(blob)
      })
    },

    async getSignatureProfiles() {
      try {
        this.signatureProfiles = await signatureProfiles.getSignatureProfiles()
        this.originalSignatureProfiles = [...this.signatureProfiles]

        this.signatureProfiles.forEach(profile => {
          delete profile.textParams
          profile.sourceImageDataUrl = profile.renderedImageDataUrl
        })
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    async listMyActivatedCredentials() {
      try {
        const resp = await rssp.listMyActivatedCredentials()

        const haveInactiveCredential = this.activatedCredentials.filter(x => x.authMode === 'IMPLICIT').length
        resp.content = resp.content.filter(cred => ((cred.keyPurpose === 'ASYMMETRIC_SIGN') && (cred.certChain.length > 0)))
        this.activatedCredentials = resp.content
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    async handleWarning() {
      try {
        const resp = await rssp.listMyCredentials()
        resp.content = resp.content.filter(elem => ((elem.keyPurpose === 'ASYMMETRIC_SIGN')))
        this.myCredentials = resp.content

        const devices = await rssp.listMyDevices()
        this.devicesListTotalItems = devices.total

        const credentialActivatedImplicitTotalItems = this.activatedCredentials.filter(x => x.authMode === 'IMPLICIT').length
        const credentialActivatedExplicitTotalItems = this.activatedCredentials.filter(x => x.authMode === 'EXPLICIT').length
        const credentialImplicitTotalItems = this.myCredentials.filter(x => x.authMode === 'IMPLICIT').length

        if (!this.sealEnabled) {
          this.noDeviceForImplicitCredentialWarningVisible = (credentialActivatedExplicitTotalItems === 0) && (this.devicesListTotalItems === 0) && (credentialImplicitTotalItems > 0)
          this.noCredentialWarningVisible = !this.noDeviceForImplicitCredentialWarningVisible && (this.activatedCredentials.length === 0)
          this.showBlueWarning = (this.myCredentials.filter(x => x.status !== 'ACTIVATED' || x.certChain.length === 0).length > 0) || (credentialActivatedImplicitTotalItems > 0 && this.devicesListTotalItems === 0)
        } else {
          this.noDeviceForImplicitCredentialWarningVisible = !this.sealActivated && (credentialActivatedExplicitTotalItems === 0) && (this.devicesListTotalItems === 0) && (credentialImplicitTotalItems > 0)
          this.showBlueWarning = !this.sealActivated && ((this.myCredentials.filter(x => x.status !== 'ACTIVATED' || x.certChain.length === 0).length > 0) || (credentialActivatedImplicitTotalItems > 0 && this.devicesListTotalItems === 0))
        }
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    updatedSignatureProfile(variable) {
      this.selectedSignatureProfile = variable
    },

    updatedTextSize(variable) {
      this.signatureTextSize = variable
    },

    async updatedSignatureProfileImage(variable) {
      this.signatureImg = variable
    },

    pdfLoaded(variable) {
      this.pdfRendered = true
      this.isUploading = false

      if (this.sealActivated && this.activatedCredentials.length === 0 && this.signatureProfiles.length === 1) {
        this.selectedSignatureProfile = this.signatureProfiles[0]
        if (!this.selectedCredential) {
          this.selectedCredential = {}
        }
        this.selectedCredential.id = this.selectedSignatureProfile.credentialId
      }
    },

    showAuthorizationModal() {
      this.authorizationModal = true
      this.$nextTick(() => {
        this.$refs.authorizationModalForm.reset()
        this.$nextTick(() => {
          this.$refs.passwordField.focus()
        })
      })
    },

    async showDeclineModal(e) {
      const opts = {
        title: this.$t('dialog.confirmation.title'),
        posX: e.clientX,
        posY: e.clientY
      }
      const conf = await showConfirmationMenu(opts)
      if (!conf) {
        return
      }
      this.declineReasonVisible = true
    },

    async signDoc() {
      const isSealSignMode = this.isSealSignMode

      if (!isSealSignMode && (!this.selectedCredential.certChain || this.selectedCredential.certChain.length === 0)) {
        showToastError(this.$t('documentSignatureCustomization.content.signature.noCertificateError'))
        return
      }

      const explicitCredential = !isSealSignMode && this.isExplicitCredential(this.selectedCredential?.authMode)
      const implicitCredential = !isSealSignMode && this.isImplicitCredential(this.selectedCredential?.authMode)

      this.authorizationModalBtnLoading = explicitCredential

      this.implicitGuid = uuidv4()

      // (elem.certChain.length > 0)))
      try {
        const signRequest = {
          useSeal: isSealSignMode
        }
        const signaturesArr = []
        const signature = {
          signatureId: this.getUserSignatureId(this.chainContainer),
          currentSignatureId: this.getCurrentSignatureId(this.chainContainer)
          // signatureFieldParameters: this.selectedSignatureProfile.savedSignatureFieldParameters
        }
        signaturesArr.push(signature)
        this.$set(signRequest, 'signatures', signaturesArr)

        if (!isSealSignMode && this.selectedCredential.id) {
          const credentialOptions = {
            description: this.implicitGuid,
            credentialId: this.selectedCredential.id
          }
          if (explicitCredential) {
            this.$set(credentialOptions, 'PIN', this.expAuthPwd.pwd)
          }
          this.$set(signRequest, 'credentialOptions', credentialOptions)
        }

        if (isSealSignMode && !this.useDifferentCredential) {
          // await this.$refs.visibleSignature.emitSignatureProfileImage()
          if (this.selectedSignatureProfile) {
            this.$set(signRequest, 'signatureProfileId', this.selectedSignatureProfile.id)

            // before siganture, we asking the current preview position (in case the widget is not moved by hand)
            // signRequest = Object.assign({}, signRequest, profileParameters)
          }
        }

        try {
          this.authorizationModalBtnLoading = true

          if (implicitCredential) {
            this.implicitAuthorizationModalKey++
            this.ImplicitAuthorizationModalVisible = true
          }
          await signatures.sign(signRequest, implicitCredential ? this.authorizationTimeoutMilis : null)
          this.back()
          showToastSuccess(this.$t('toastMessage.succesfullySigned'))
        } catch (error) {
          const errorMsg = this.getErrorMessage(error)
          showToastError(errorMsg)
        }
      } catch (error2) {
        console.error('signDoc, exception occured', error2)
        showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
      } finally {
        this.authorizationModalBtnLoading = false
        this.ImplicitAuthorizationModalVisible = false
        this.authorizationModal = false
      }
    },

    isExplicitCredential(authMode) {
      return authMode === CredentialAuthMode.EXPLICIT
    },

    isImplicitCredential(authMode) {
      return authMode === CredentialAuthMode.IMPLICIT
    },

    back() {
      this.declineReasonVisible = false
      this.$router.push({ name: 'SignatureChains' })
    },

    getUserSignatureId(item) {
      const userSignature = item.signatures.find(signature => (!!signature.user && signature.user.id === this.currentUser.id && signature.status === SignatureChainStatus.CREATED))
      return userSignature.id
    },

    getCurrentSignatureId(item) {
      if (item.type === SignatureChainType.UNORDERED && !!item.currentSignatureId) {
        return item.currentSignatureId
      } else return undefined
    },

    logValidationErrors() {
      // Check if errorBag exists and is an object
      if (this.$refs.form.errorBag && typeof this.$refs.form.errorBag === 'object') {
        // Iterate through errorBag and log error messages and rules
        for (const fieldName in this.$refs.form.errorBag) {
          const fieldErrors = this.$refs.form.errorBag[fieldName]
          if (Array.isArray(fieldErrors)) {
            fieldErrors.forEach(error => {
              console.error(error)
            })
          } else if (typeof fieldErrors === 'string') {
            console.error(`Field: ${fieldName}, Error Message: ${fieldErrors}`)
          } else {
            // Handle if fieldErrors is not an array or string
            console.error(`Unexpected errorBag structure for field ${fieldName}:`, fieldErrors)
          }
        }
      } else {
        console.error('ErrorBag is not properly defined or is not an object')
      }
    },
    handleFormValidityChange(valid) {
      // valid parameter indicates whether the form is valid or not
      if (!valid) {
        // Additional actions you may want to take when a validation error occurs
        this.logValidationErrors()
      }
    }
  }
}
</script>

<style>
.BlueWarning {
  color: var(--v-accent-base);
}
</style>
